import { graphql, HeadProps } from 'gatsby';
import { useEffect } from 'react';
import { PageComponents } from '../components/episerver/page';
import { Seo } from '../components/seo';
import { usePageContext } from '../contexts/PageProvider';
import { PageContextType } from '../global';

const NewsEventsPageTemplate = ({ data }) => {
  const { pageContext, setPageExternalImages } = usePageContext();
  const { id, endpoint } = pageContext;

  const pageContent = data[endpoint]?.edges.find(({ node }) => node?.id === id)?.node || null;

  useEffect(() => {
    setPageExternalImages(pageContent?.externalFiles || []);
  }, [setPageExternalImages, pageContent]);

  const updatedData = {
    content: pageContent,
    endpoint
  };

  return <PageComponents data={updatedData} />;
};

export function Head({ pageContext, location }: HeadProps<unknown, PageContextType>) {
  const { meta, slug } = pageContext;
  return (
    <Seo
      slug={slug}
      location={location}
      title={meta?.title || ''}
      keywords={meta?.keywords || ''}
      description={meta?.description || ''}
    />
  );
}

export const Query = graphql`
  query {
    ...OptimizelyArticlePageContentChildren
  }
`;

export default NewsEventsPageTemplate;
